import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f5e5e1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log-wrap nongfu-checkbox-wrap" }
const _hoisted_2 = { class: "time" }
const _hoisted_3 = { class: "logs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "log-name" }
const _hoisted_7 = { class: "time-range" }

import { Checkbox } from 'vant'
import { showNormalToast } from '@/utils/tools'
import { ref, withDefaults, computed, ComputedRef } from 'vue'
import type { FormatDeviceFlyLogsItem, GetDeviceFlyLogsItem } from '@/types/malfunction-repair'
import dayjs from 'dayjs'
import FaultLogItemTag from './fault-logitem-tag.vue'

interface RenderLogGroupItem {
  date: string // 日期
  list: Array<FormatDeviceFlyLogsItem>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'flylog-group',
  props: {
    guid: { default: '' },
    guids: { default: () => [] },
    list: { default: () => [] },
    multiple: { type: Boolean, default: false },
    maxLength: { default: Infinity },
    limitMaxTips: { default: '' }
  },
  emits: ['change'],
  setup(__props: any, { emit: emits }) {

const props = __props as { guid: string, guids: string[], list: Array<GetDeviceFlyLogsItem>, multiple: boolean, maxLength: number, limitMaxTips: string };



const active = ref(props.guid)
const actives = ref(props.guids)
const flylogGroups: ComputedRef<RenderLogGroupItem[]> = computed(() => {
  // 格式化飞行日志进行分组
  const data = props.list.map((item) => {
    const formatStartAtArr = dayjs(item.startAt * 1000)
      .format('YYYY年MM月DD日 HH:mm:ss')
      .split(' ')
    const formatEndAtArr = dayjs(item.endAt * 1000)
      .format('YYYY年MM月DD日 HH:mm:ss')
      .split(' ')
    const date = formatStartAtArr[0] // 理论上开始时间和结束时间在一天内
    const timeRange = `${formatStartAtArr[1]}-${formatEndAtArr[1]}`
    return {
      ...item,
      date,
      timeRange,
    }
  })
  const result = data.reduce((result, item) => {
    const current = result[result.length - 1] || null
    if (!current || current.date !== item.date) {
      result.push({
        date: item.date,
        list: [],
      })
    }
    result[result.length - 1].list.push({
      ...item,
    })
    return result
  }, [] as RenderLogGroupItem[])
  return result
})
function getCheckboxModalValue(guid: string) {
  if (!props.multiple) {
    return guid === active.value
  } else {
    return actives.value.indexOf(guid) !== -1
  }
}
function clickHandle(data: FormatDeviceFlyLogsItem) {
  const isMultiple = props.multiple
  if (isMultiple) {
    if (actives.value.indexOf(data.guid) !== -1) {
      actives.value = actives.value.filter((guid) => guid !== data.guid)
    } else {
      if (actives.value.length < props.maxLength) {
        actives.value.push(data.guid)
      } else if (props.limitMaxTips) {
        showNormalToast({
          message: props.limitMaxTips,
          position: 'bottom',
        })
      }
    }
    emits('change', actives.value)
  } else {
    active.value = data.guid
    emits('change', active.value)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flylogGroups), (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(item.date), 1),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (logItem) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "log-item",
                key: logItem.guid,
                onClick: ($event: any) => (clickHandle(logItem))
              }, [
                _createVNode(_unref(Checkbox), {
                  modelValue: getCheckboxModalValue(logItem.guid),
                  "icon-size": "20px",
                  class: "checkbox-item"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(logItem.timeRange), 1),
                    _createVNode(FaultLogItemTag, {
                      isBoom: logItem.isBoom
                    }, null, 8, ["isBoom"])
                  ]),
                  _createElementVNode("div", _hoisted_7, "时长 " + _toDisplayString(logItem.longStr), 1)
                ])
              ], 8, _hoisted_4))
            }), 128))
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})